/**
 * Homepage slider script
 */
 class SW_HomeSlider {
  constructor() {
    this.initState();
  }

  initState() {
    this.sliderWrapper = $('.slider-wrapper');
    this.prevBtn = this.sliderWrapper.find('.prev');
    this.nextBtn = this.sliderWrapper.find('.next');
    this.list = this.sliderWrapper.find('.slider-list');
    this.items = this.list.find('.slider-item');
    this.currentItem = 0;
    this.animationInProgress = false;

    if (!this.sliderWrapper.length) {
      return
    }

    this.initEvents();
  }

  initEvents() {
    this.swipeEffect = new Hammer(this.sliderWrapper[0]);
          
    this.nextBtn.on('click', e => {
      e.preventDefault();

      if (this.animationInProgress) {
        return;
      }

      this.currentItem++;
      this.animationInProgress = true;

      if (this.currentItem >= this.items.length) {
        this.currentItem = 0;
      }

      this.list.css('margin-left', (-100 * this.currentItem) + "%");

      setTimeout(() => {
        this.animationInProgress = false;
      }, 550);
    });

    this.prevBtn.on('click', e => {
      e.preventDefault();

      if (this.animationInProgress) {
        return;
      }

      this.currentItem--;
      this.animationInProgress = true;

      if (this.currentItem < 0) {
        this.currentItem = this.items.length - 1;
      }

      this.list.css('margin-left', (-100 * this.currentItem) + "%");

      setTimeout(() => {
          this.animationInProgress = false;
      }, 550);
    });

    this.swipeEffect.on('swipe', ev => {
      if (ev.type === 'swipe' && ev.direction === 2 && ev.deltaX < -30) {
        this.nextBtn.trigger('click');
      }

      if (ev.type === 'swipe' && ev.direction === 4 && ev.deltaX > 30) {
        this.prevBtn.trigger('click');
      }
    });
  }
}